/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

type SvgProficiencyLevelsProps = React.SVGProps<SVGSVGElement>;

const SvgProficiencyLevels: React.FC<SvgProficiencyLevelsProps> = (props) => {
  const styles = {
    wrapper: css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    `,

    text: css`
      font-weight: bold;
      font-size: 14px;
      color: var(--cds-color-grey-400);
    `,
  };

  // NOTE1: Even in RTL language, progress bar-like things (like this score bar) should be LTR.
  //
  // NOTE2: we must set direction: ltr with the `style` HTML attr,
  // since the `css` provided by emotion will flip the direction,
  // so setting `direction: ltr` would be flipped to `direction: rtl`.
  return (
    <div aria-hidden role="presentation" css={styles.wrapper} style={{ direction: 'ltr' }}>
      <span css={styles.text}>0</span>
      <svg width={320} height={24} viewBox="0 0 320 24" role="presentation" {...props}>
        <g fill="none" fillRule="evenodd">
          <path fill="var(--cds-color-grey-700)" d="M106.667 5h118v14h-118z" stroke="black" />
          <path d="M228 5h80a7 7 0 010 14h-80V5z" fill="var(--cds-color-neutral-primary)" stroke="black" />
          <path fill="var(--cds-color-grey-400)" d="M44.334 5h59v14h-59z" stroke="black" />
          <path d="M18 5h23v14H18a7 7 0 010-14z" fill="var(--cds-color-grey-200)" stroke="black" />
        </g>
      </svg>
      <span css={styles.text}>500</span>
    </div>
  );
};

export default SvgProficiencyLevels;
